export const nounClauseQuestions = [
  {
    questionNumber: 1,
    questionText: "Do you know where the meeting will be held?",
    choices: {
      A: "Yes, it's in Conference Room B.",
      B: "The agenda was sent earlier.",
      C: "The IT team is upgrading the system.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의가 어디서 열릴지 아시나요?",
      choices: {
        A: "네, 회의실 B에서 열립니다.",
        B: "회의 안건이 이미 발송되었습니다.",
        C: "IT팀이 시스템을 업그레이드하고 있습니다.",
      },
    },
    explanation:
      "'Do you know where...'와 같은 명사절 의문문에는 'Yes/No'로 시작하여 뒤에 구체적인 정보를 덧붙여 답변합니다. A는 'Yes'로 시작하고 정확한 회의 장소를 알려주는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 2,
    questionText: "Can you tell me where the nearest bus stop is?",
    choices: {
      A: "The bus runs every 15 minutes.",
      B: "I think it's two blocks down, but I'll check.",
      C: "The train station is farther away.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "가장 가까운 버스 정류장이 어디 있는지 알려주시겠어요?",
      choices: {
        A: "버스가 15분마다 운행합니다.",
        B: "두 블록 아래에 있는 것 같은데, 확인해보겠습니다.",
        C: "기차역은 더 멀리 있습니다.",
      },
    },
    explanation:
      "명사절 의문문에서 정확한 위치를 모를 때는, 알고 있는 만큼의 정보를 제공하고 확인하겠다는 의사를 함께 표현하는 것이 적절합니다. 따라서 대략적인 위치를 언급하고 확인하겠다는 내용을 담은 B가 정답입니다.",
  },
  {
    questionNumber: 3,
    questionText: "Can you tell me where I can find an ATM?",
    choices: {
      A: "The bank opens at 9 a.m.",
      B: "The post office is nearby.",
      C: "Yes, there's one next to the entrance.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "ATM이 어디 있는지 알려주시겠어요?",
      choices: {
        A: "은행은 오전 9시에 문을 엽니다.",
        B: "우체국이 근처에 있습니다.",
        C: "네, 입구 옆에 하나 있습니다.",
      },
    },
    explanation:
      "'Can you tell me where...'와 같은 명사절 의문문에는 'Yes'로 시작하여 구체적인 위치 정보를 제공하는 것이 적절합니다. C는 'Yes'로 시작하고 ATM의 정확한 위치를 알려주는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 4,
    questionText: "Do you know which department the new employee is in?",
    choices: {
      A: "I think she's in marketing, but I'll confirm.",
      B: "The HR team handles employee records.",
      C: "The cafeteria serves lunch from noon.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새 직원이 어느 부서에 있는지 아시나요?",
      choices: {
        A: "마케팅부에 있는 것 같은데, 확인해보겠습니다.",
        B: "HR팀이 직원 기록을 관리합니다.",
        C: "구내식당은 정오부터 점심을 제공합니다.",
      },
    },
    explanation:
      "명사절 의문문에서 정확하지 않은 정보를 전달할 때는 'I think(~인 것 같다)'로 시작하여 알고 있는 정보를 말하고, 'but I'll confirm(확인해보겠다)'으로 추가 확인 의사를 표현하는 것이 적절합니다. A는 이러한 답변 방식을 잘 보여줍니다.",
  },
  {
    questionNumber: 5,
    questionText: "Do you know where the HR department is?",
    choices: {
      A: "The HR team handles employee benefits.",
      B: "The IT department is next to the break room.",
      C: "Yes, it's on the second floor.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "HR부서가 어디 있는지 아시나요?",
      choices: {
        A: "HR팀이 직원 복리후생을 담당합니다.",
        B: "IT부서는 휴게실 옆에 있습니다.",
        C: "네, 2층에 있습니다.",
      },
    },
    explanation:
      "'Do you know where...'와 같은 명사절 의문문에는 'Yes'로 시작하여 구체적인 위치 정보를 제공하는 것이 적절합니다. C는 'Yes'로 시작하고 HR부서의 정확한 위치를 알려주는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 6,
    questionText: "Can you tell me how much the museum ticket costs?",
    choices: {
      A: "The museum has a large art collection.",
      B: "I believe it's $15, but I'll double-check.",
      C: "The coffee shop inside is popular.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "박물관 입장권이 얼마인지 알려주시겠어요?",
      choices: {
        A: "박물관에는 큰 미술 컬렉션이 있습니다.",
        B: "15달러인 것 같은데, 다시 한 번 확인해보겠습니다.",
        C: "안에 있는 커피숍이 인기가 있습니다.",
      },
    },
    explanation:
      "명사절 의문문에서 정확하지 않은 가격 정보를 전달할 때는 'I believe(~인 것 같다)'로 시작하여 알고 있는 정보를 말하고, 'but I'll double-check(다시 확인해보겠다)'로 재확인 의사를 표현하는 것이 적절합니다. B는 이러한 답변 방식을 잘 보여줍니다.",
  },
  {
    questionNumber: 7,
    questionText: "Do you know if the contract has been signed?",
    choices: {
      A: "I'm not sure, let me check with legal.",
      B: "The contract includes a confidentiality clause.",
      C: "The project deadline was extended.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "계약서에 서명이 되었는지 아시나요?",
      choices: {
        A: "잘 모르겠네요, 법무팀에 확인해보겠습니다.",
        B: "계약서에는 기밀유지 조항이 포함되어 있습니다.",
        C: "프로젝트 기한이 연장되었습니다.",
      },
    },
    explanation:
      "명사절 의문문에서 정보를 확실히 모를 때는 'I'm not sure(잘 모르겠다)'로 시작하여 'let me check(확인해보겠다)'로 확인하겠다는 의사를 표현하는 것이 적절합니다. A는 이러한 답변 방식을 잘 보여줍니다.",
  },
  {
    questionNumber: 8,
    questionText: "Can you tell me where the nearest post office is?",
    choices: {
      A: "The post office sells packaging materials.",
      B: "The grocery store is next to it.",
      C: "Yes, it's on the next block.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "가장 가까운 우체국이 어디 있는지 알려주시겠어요?",
      choices: {
        A: "우체국에서 포장 용품을 판매합니다.",
        B: "식료품점이 그 옆에 있습니다.",
        C: "네, 다음 블록에 있습니다.",
      },
    },
    explanation:
      "'Can you tell me where...'와 같은 명사절 의문문에는 'Yes'로 시작하여 구체적인 위치 정보를 제공하는 것이 적절합니다. C는 'Yes'로 시작하고 우체국의 정확한 위치를 알려주는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 9,
    questionText: "Can you tell me when the next team meeting is?",
    choices: {
      A: "The conference room is on the second floor.",
      B: "Yes, it's scheduled for Friday at 2 p.m.",
      C: "The office cafeteria serves lunch from noon.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "다음 팀 회의가 언제인지 알려주시겠어요?",
      choices: {
        A: "회의실은 2층에 있습니다.",
        B: "네, 금요일 오후 2시로 예정되어 있습니다.",
        C: "사무실 구내식당은 정오부터 점심을 제공합니다.",
      },
    },
    explanation:
      "'Can you tell me when...'와 같은 명사절 의문문에는 'Yes'로 시작하여 구체적인 시간 정보를 제공하는 것이 적절합니다. B는 'Yes'로 시작하고 회의 날짜와 시간을 정확하게 알려주는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 10,
    questionText: "Could you tell me when the report is due?",
    choices: {
      A: "The report contains financial data.",
      B: "The HR department manages employee benefits.",
      C: "I believe it's next Wednesday, but I'll confirm.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "보고서 마감이 언제인지 알려주시겠어요?",
      choices: {
        A: "보고서에는 재무 데이터가 포함되어 있습니다.",
        B: "HR부서가 직원 복리후생을 관리합니다.",
        C: "다음 주 수요일인 것 같은데, 확인해보겠습니다.",
      },
    },
    explanation:
      "명사절 의문문에서 정확하지 않은 날짜 정보를 전달할 때는 'I believe(~인 것 같다)'로 시작하여 알고 있는 정보를 말하고, 'but I'll confirm(확인해보겠다)'으로 재확인 의사를 표현하는 것이 적절합니다. C는 이러한 답변 방식을 잘 보여줍니다.",
  },
  {
    questionNumber: 11,
    questionText: "Do you know what time the post office closes?",
    choices: {
      A: "I think it stays open late on weekdays.",
      B: "I need to buy some stamps.",
      C: "There's a post office across the street.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "우체국이 몇 시에 문을 닫는지 아시나요?",
      choices: {
        A: "평일에는 늦게까지 열려있는 것 같아요.",
        B: "우표를 사야 해요.",
        C: "길 건너편에 우체국이 있어요.",
      },
    },
    explanation:
      "'Do you know what time...'이라는 명사절 의문문에 대해, A는 직접적인 시간을 언급하지는 않지만 우체국의 운영 시간에 대한 유용한 정보를 제공하는 적절한 답변입니다. B와 C는 우체국과 관련은 있지만 질문한 마감 시간과는 무관한 답변입니다.",
  },
  {
    questionNumber: 12,
    questionText: "Do you know what time the client is expected to arrive?",
    choices: {
      A: "Yes, he should be here by 3 p.m.",
      B: "The client requested a product demonstration.",
      C: "The IT team is working on system maintenance.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "고객이 몇 시에 도착할 예정인지 아시나요?",
      choices: {
        A: "네, 오후 3시까지 도착할 예정입니다.",
        B: "고객이 제품 시연을 요청했습니다.",
        C: "IT팀이 시스템 유지보수 작업을 하고 있습니다.",
      },
    },
    explanation:
      "'Do you know what time...'와 같은 명사절 의문문에는 'Yes'로 시작하여 구체적인 시간 정보를 제공하는 것이 적절합니다. A는 'Yes'로 시작하고 고객의 예상 도착 시간을 정확하게 알려주는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 13,
    questionText: "I wonder what the contract includes.",
    choices: {
      A: "The legal team reviews all contracts.",
      B: "The office renovation will start next month.",
      C: "It covers payment terms and confidentiality.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "계약서에 무엇이 포함되어 있는지 궁금합니다.",
      choices: {
        A: "법무팀이 모든 계약서를 검토합니다.",
        B: "사무실 리모델링은 다음 달에 시작됩니다.",
        C: "지불 조건과 기밀유지 조항이 포함되어 있습니다.",
      },
    },
    explanation:
      "'I wonder what...'와 같은 명사절 의문문에는 질문한 내용에 대한 구체적인 정보를 직접적으로 제공하는 것이 적절합니다. C는 계약서의 구체적인 내용을 명확하게 설명하는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 14,
    questionText: "I wonder why she was chosen as the team leader.",
    choices: {
      A: "The team meeting is scheduled for Friday.",
      B: "She has the most experience in this field.",
      C: "The company cafeteria serves vegetarian meals.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그녀가 왜 팀장으로 선택되었는지 궁금합니다.",
      choices: {
        A: "팀 회의는 금요일로 예정되어 있습니다.",
        B: "그녀가 이 분야에서 가장 경험이 많습니다.",
        C: "회사 구내식당에서 채식 메뉴를 제공합니다.",
      },
    },
    explanation:
      "'I wonder why...'와 같은 명사절 의문문에는 질문한 내용에 대한 구체적인 이유나 근거를 제공하는 것이 적절합니다. B는 팀장 선정 이유를 그녀의 경험과 연관지어 명확하게 설명하는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 15,
    questionText: "I'm not sure what time the train arrives.",
    choices: {
      A: "The train station has a new waiting area.",
      B: "Let me check the schedule.",
      C: "The bus stop is across the street.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "기차가 몇 시에 도착하는지 잘 모르겠습니다.",
      choices: {
        A: "기차역에 새로운 대기 공간이 있습니다.",
        B: "시간표를 확인해보겠습니다.",
        C: "버스 정류장은 길 건너편에 있습니다.",
      },
    },
    explanation:
      "'I'm not sure what time...'와 같이 정보를 모르는 상황의 명사절 의문문에는 'Let me check(확인해보겠다)'로 확인하겠다는 의사를 표현하는 것이 적절합니다. B는 시간표를 확인하겠다는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 16,
    questionText: "I don't know which restaurant serves the best seafood.",
    choices: {
      A: "The one near the harbor is highly rated.",
      B: "The menu includes a variety of dishes.",
      C: "The coffee shop next door is very popular.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "어느 식당이 해산물을 가장 잘하는지 모르겠습니다.",
      choices: {
        A: "항구 근처에 있는 곳이 평가가 아주 좋습니다.",
        B: "메뉴에 다양한 요리가 포함되어 있습니다.",
        C: "옆에 있는 커피숍이 매우 인기가 있습니다.",
      },
    },
    explanation:
      "'I don't know which...'와 같은 명사절 의문문에는 질문한 내용에 대한 구체적인 추천이나 정보를 제공하는 것이 적절합니다. A는 최고의 해산물 식당으로 항구 근처 식당을 추천하고 그 이유를 설명하는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 17,
    questionText: "I wonder when the project will start.",
    choices: {
      A: "The project requires multiple teams.",
      B: "The company is launching a new product.",
      C: "It's scheduled to begin next Monday.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "프로젝트가 언제 시작될지 궁금합니다.",
      choices: {
        A: "이 프로젝트는 여러 팀이 필요합니다.",
        B: "회사가 새로운 제품을 출시합니다.",
        C: "다음 주 월요일에 시작하기로 예정되어 있습니다.",
      },
    },
    explanation:
      "'I wonder when...'와 같은 명사절 의문문에는 질문한 시기에 대한 구체적인 정보를 제공하는 것이 적절합니다. C는 프로젝트의 정확한 시작 날짜를 알려주는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 18,
    questionText: "I wonder how the new remote work policy works.",
    choices: {
      A: "Employees can work from home twice a week.",
      B: "The HR department handles remote work requests.",
      C: "The office parking lot is under maintenance.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새로운 재택근무 정책이 어떻게 운영되는지 궁금합니다.",
      choices: {
        A: "직원들은 주 2회 재택근무를 할 수 있습니다.",
        B: "HR부서에서 재택근무 신청을 처리합니다.",
        C: "사무실 주차장이 공사 중입니다.",
      },
    },
    explanation:
      "'I wonder how...'와 같은 명사절 의문문에는 질문한 내용의 구체적인 운영 방식이나 절차를 설명하는 것이 적절합니다. A는 새로운 재택근무 정책의 핵심 내용을 명확하게 설명하는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 19,
    questionText: "I'm not sure where the concert will be held.",
    choices: {
      A: "The concert tickets are already sold out.",
      B: "Let me check the event website.",
      C: "The shopping mall has a food court.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "콘서트가 어디서 열릴지 잘 모르겠습니다.",
      choices: {
        A: "콘서트 티켓이 이미 매진되었습니다.",
        B: "이벤트 웹사이트에서 확인해보겠습니다.",
        C: "쇼핑몰에 푸드코트가 있습니다.",
      },
    },
    explanation:
      "'I'm not sure where...'와 같이 정보를 모르는 상황의 명사절 의문문에는 'Let me check(확인해보겠다)'로 확인하겠다는 의사를 표현하는 것이 적절합니다. B는 이벤트 웹사이트에서 확인하겠다는 적절한 답변 방식을 보여줍니다.",
  },
  {
    questionNumber: 20,
    questionText: "The issue is why the project is behind schedule.",
    choices: {
      A: "It was delayed due to supplier issues.",
      B: "The project involves multiple teams.",
      C: "The IT department is hiring new staff.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "문제는 프로젝트가 왜 일정보다 늦어지고 있는가입니다.",
      choices: {
        A: "공급업체 문제로 인해 지연되었습니다.",
        B: "이 프로젝트는 여러 팀이 참여합니다.",
        C: "IT부서에서 새로운 직원을 채용하고 있습니다.",
      },
    },
    explanation:
      "'The issue is why...'와 같은 명사절 의문문에는 질문한 문제의 구체적인 원인이나 이유를 설명하는 것이 적절합니다. A는 프로젝트 지연의 직접적인 원인을 명확하게 설명하는 적절한 답변 방식을 보여줍니다.",
  },
];
